import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { allIcons } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import { color } from "@amcharts/amcharts5";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const AddConfirmDialog = forwardRef((props, ref) => {
  const { handleCreateTeamMember, open, setOpen } = props;

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  console.log(paramsData, "paramsDataparamsDataparamsDataparamsData");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Box my={3} textAlign={"center"}>
        <img src={allIcons.alertIcon} alt={"confirm-icon"} width={40} />
      </Box>
      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2, textAlign: "center" }}
        id="customized-dialog-title"
      >
        Confirmation !{" "}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" textAlign={"center"} color={"primary.main"}>
          Are you sure your want to add a new team member?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "space-around",
          alignItems: "center",
          paddingY: "10px",
        }}
      >
        <GlobalButton
          btnText={"Cancel"}
          handleClickBtn={handleClose}
          styleProps={{
            width: 200,
            height: 40,
            bgcolor: "white",
            color: "#EA580C",
          }}
          hoverProperties={{
            bgcolor: "#FFF",
            color: "#EA580C",
          }}
        />
        <GlobalButton
          btnText={"Done"}
          handleClickBtn={() => handleCreateTeamMember(paramsData)}
          styleProps={{ width: 200, height: 40 }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddConfirmDialog;
